import React from 'react';
import api from '../services/api';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import Divider from 'material-ui/Divider';
import Subheader from 'material-ui/Subheader';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import RaisedButton from 'material-ui/RaisedButton';

class Update extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [
        <TableRow key={null}>
          <TableRowColumn>Carregando...</TableRowColumn>
        </TableRow>],
      rawData: [],
      offset: 0,
      search: "",
      isOpen: false,
      selectedRecord: null,
      total: 0
    };
  }
  componentDidMount() {
    var self = this;
    this.updateData();
  }
  componentDidUpdate(prevProps, nextState) {
    if (this.state.offset !== nextState.offset)
      this.updateData();
  }
  handleAuthorization = () => {
    var self = this;
    api.getUpdateDataAuthorization().then((rs) => {
      this.timer = setInterval(function(){
        self.updateData();
      },1000);      
    }).catch((error) => {
      console.log("error", error);
      console.error(error);
    });
  }
  handleClose = () => {
    this.setState({ isOpen: false });
  }
  handleNext = () => {
    this.setState({ offset: this.state.offset + 1 });
  }
  handleBefore = () => {
    this.setState({ offset: this.state.offset - 1 });
  }
  handleSelect = (index) => {
    var rec = this.state.rawData[index];
    var content = Object.keys(rec).map(function (key) {
      return <p><b>{key}: </b>{rec[key]}</p>;
    });
    this.setState({ selectedRecord: content });
    this.setState({ isOpen: true });
  }
  updateData() {
    var self = this;
    api.getUpdateData(null, self.state.offset).then((rs) => {
      var aux = [];
      var rawData = [];
      self.setState({ total: rs.response.total });
      var aux = rs.response.records.map(function (item) {
        rawData.push(item.rawData);
        return <TableRow key={item.id} >
          <TableRowColumn style={{ width: "10%" }}>{item.rawData.codpes}</TableRowColumn>
          <TableRowColumn style={{ width: "30%" }}>{item.rawData.nompes}</TableRowColumn>
          <TableRowColumn style={{ width: "30%" }}>{item.rawData.nomundcur}</TableRowColumn>
          <TableRowColumn style={{ width: "10%" }}>{item.rawData.anoccl}</TableRowColumn>
          <TableRowColumn style={{ width: "20%" }}>{item.timestamp}</TableRowColumn>
        </TableRow>;
      });      
      this.setState({ rawData: rawData });
      this.setState({ data: aux });
      if(this.timer && rs.response.total==0)
        clearInterval(this.timer);
    }).catch((error) => {
      console.error(error);
    });
  }
  render() {
    const actions = [
      <FlatButton
        label="OK"
        primary={true}
        onTouchTap={this.handleClose}
      />
    ];
    var first = this.state.offset == 0;
    var from = this.state.offset * 10 + 1;
    var to = from + 10;
    var last = to > this.state.total;
    if (last) to = this.state.total;
    var disableAuthorization = (this.timer || this.state.total==0);
    return (
      <div style={{ width: "100%" }} >
        <br /><h1>Atualização de dados</h1>
        <Table onRowSelection={this.handleSelect}>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>
              <TableHeaderColumn style={{ width: "10%" }}>Identificador</TableHeaderColumn>
              <TableHeaderColumn style={{ width: "30%" }}>Nome</TableHeaderColumn>
              <TableHeaderColumn style={{ width: "30%" }}>Unidade</TableHeaderColumn>
              <TableHeaderColumn style={{ width: "10%" }}>Ano de Conclusão</TableHeaderColumn>
              <TableHeaderColumn style={{ width: "20%" }}>Data da Atualização</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody>
            {this.state.data}
          </TableBody>
        </Table>
        <FlatButton
          label="Anterior"
          primary={true}
          disabled={first}
          onTouchTap={this.handleBefore}
        />
        <FlatButton style={{ float: "right" }}
          label="Próximo"
          primary={true}
          disabled={last}
          onTouchTap={this.handleNext}
        />
        <p style={{ textAlign: "center" }}>
          Exibindo de {from} a {to} do total de {this.state.total}
        </p>
        <Divider />
        <div style={{ width: "100%", textAlign: "center" }}>
          <h3>Autorizar atualização</h3>

          <p>Ao clicar em "Autorizar", todos os dados acima listados serão automaticamente enviados para o portal Alumni. <b>Certifique-se que os dados estão livres de erros.</b></p>
          <RaisedButton onClick={this.handleAuthorization} disabled={disableAuthorization} label="Autorizar" primary={true} style={{ maring: "12px" }} />
        </div>
        <Dialog
          title="Registro da fonte"
          actions={actions}
          modal={false}
          open={this.state.isOpen}
          onRequestClose={this.handleClose}
        >
          {this.state.selectedRecord}
        </Dialog>
      </div>
    )
  }
};
export default Update;


// WEBPACK FOOTER //
// ./src/pages/Update.js